import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IDeleteInvoiceRequest extends IBaseRequest {
  id: string;
  treeHandle?: string;
}

export class DeleteInvoiceRequest extends BaseRequest implements IDeleteInvoiceRequest {
  public id: string;
  public treeHandle?: string;

  constructor(server: string, session: string, id: string, treeHandle?: string) {
    super(server, session);
    this.id = id;
    this.treeHandle = treeHandle;
  }

  public toXml(): string {
    let parameters = super.toXml();
    parameters += `<INVOICE>${this.makeNode(this.id, 'id')}${this.makeNode(
      this.treeHandle,
      'treeHandle'
    )}</INVOICE>`;
    return super.wrapperXml('DeleteInvoice', parameters);
  }
}
